import {getModule, Module, Mutation, VuexModule} from "vuex-module-decorators"
import {RootStore} from "@/store/RootStore"

@Module({namespaced: true, name: 'auth'})
export default class AuthStore extends VuexModule {
  email: string | null = null
  token: string | null = null
  role: string | null = null
  authorized: boolean = false

  static get module() {
    return getModule(AuthStore, RootStore)
  }

  get isAuthorized(): boolean {
    return this.token !== null && this.authorized
  }

  get isAdmin(): boolean {
    return this.role === 'admin'
  }

  get isFbReviewer(): boolean {
    return this.role === 'fb-reviewer'
  }

  // Mirrors allowed_jobs() in src/http/routes/jobs.rs: other roles get 403 on /v0/jobs.
  get canSeeJobs(): boolean {
    return this.role === 'admin' || this.role === 'fb-reviewer'
  }

  @Mutation
  logout() {
    this.authorized = false
    this.token = null
    this.email = null
    this.role = null
  }

  @Mutation
  setSession([email, token, role]: [string, string, string]) {
    this.email = email
    this.token = token
    this.role = role
  }

  @Mutation
  setAuthorized() {
    this.authorized = true
  }
}
